import styled from 'styled-components/macro'
import GoldenBg from 'assets/golden-bg.webp'
import { mq } from 'styles/mq'

export const HeaderWrapper = styled.div`
  overflow: hidden;
`

export const Header = styled.div<{ ratio: string; imageUrl: string }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 -40%;
  width: 180%;
  aspect-ratio: ${props => props.ratio};
  overflow: hidden;
  background: url('${props => props.imageUrl}') center center / contain
    no-repeat;

  ${mq.medium} {
    margin: 2.5rem auto 3rem;
    width: auto;
    max-width: calc(10 * var(--grid-size) + 11 * var(--gap-size));
  }

  &::before,
  &::after {
    content: '';
    display: flex;
    flex: 1;
  }

  &::before {
    flex: 2;
  }

  h1 {
    margin: 0;
    font-size: clamp(5.2rem, 6.5vw, 8.8rem);
    font-weight: 500;
    color: transparent;
    background: url(${GoldenBg}) center center / 600px auto no-repeat;
    -webkit-background-clip: text;
    background-clip: text;
  }
`
